import { Modal } from "antd";
import { useCallback, useRef } from "react";
import FormTag from "./Form";

const CreateTag = ({ onSubmit, data, ...props }) => {
  const formRef = useRef(null);

  const okHandler = useCallback(() => formRef.current.onSubmit(), []);

  const afterOpenChangeHandler = useCallback((value) => {
    if (value) {
      formRef.current?.onNameFocus();
    }
  }, []);

  return (
    <Modal
      afterOpenChange={afterOpenChangeHandler}
      forceRender
      onOk={okHandler}
      destroyOnHidden
      {...props}
    >
      <FormTag data={data} onSubmit={onSubmit} ref={formRef} />
    </Modal>
  );
};

CreateTag.displayName = "CreateTag";

export default CreateTag;
